import axios from 'axios'

export const fetchStationData = async (path, stationName) => {
  try {
    const res = await axios.get(path, {
      params: {station_name: stationName}
    })

    if (!res.data.length) return []

    return res.data
  } catch (e) {
    console.log(e)
  }
}

export const fetchAddress = async (query) => {
  try {
    const { data } = await axios.get('/api/v1/search/address', {
      params: {address: query}
    })

    if (!data) return []

    return data
  } catch (e) {
    console.log(e)
  }
}

export const fetchUsers = async (userParam) => {

  try {
    const res = await axios.get('/api/v1/search/users', {
      params: { user_param: userParam }
    })

    if (!res.data.length) return []

    return res.data
  } catch (e) {
    console.log(e)
  }
}
